import { string } from "prop-types"
import React from "react"

export default function LinkUrl(props) {
  const { description, url, title, className } = props

  return (
    <a
      href={url}
      target="_blank"
      rel="noopener noreferrer"
      title={title}
      className={className}
    >
      {description}
    </a>
  )
}

LinkUrl.propTypes = {
  description: string.isRequired,
  url: string.isRequired,
  title: string.isRequired,
  className: string
}
